import { lazy } from "react";

export const Dashboard = lazy(async () => await import("../pages/dashboard"));
export const WbAccounts = lazy(async () => await import("../pages/wildberries/wb.accounts"));
export const WbProducts = lazy(async () => await import("../pages/wildberries/wb.products"));
export const WbStats = lazy(async () => await import("../pages/wildberries/wb.stats"));
export const OzoneAccounts = lazy(async () => await import("../pages/ozone/ozone.accounts"));
export const OzoneProducts = lazy(async () => await import("../pages/ozone/ozone.products"));
export const OzoneStats = lazy(async () => await import("../pages/ozone/ozone.stats"));
export const Users = lazy(async () => await import("../pages/shared/users"));
export const Review = lazy(async () => await import("../pages/shared/services/review/review"));
export const ArticleDashboard = lazy(
  async () => await import("../pages/shared/services/review/article.dashboard")
);
export const ArticleProblems = lazy(
  async () => await import("../pages/shared/services/review/article.problems")
);
export const Support = lazy(async () => await import("../pages/shared/support"));
export const CategoriesLayout = lazy(
  async () => await import("../pages/shared/services/categories/categories.layout")
);
export const CategoriesOverview = lazy(
  async () => await import("../pages/shared/services/categories/categories.overview")
);
export const CategoriesBrands = lazy(
  async () => await import("../pages/shared/services/categories/categories.brands")
);
export const CategoriesPricing = lazy(
  async () => await import("../pages/shared/services/categories/categories.pricing")
);
export const CompetitorService = lazy(
  async () => await import("../pages/shared/services/competitors/layout")
);
// export const Menu = lazy(async () => await import("../pages/admin/menu"));
export const CompetitorsMain = lazy(
  async () => await import("../pages/shared/services/competitors/main/main")
);
export const SaleChannelsService = lazy(
  async () => await import("../pages/shared/services/sale-channels/layout")
);
export const SaleChannelsOverview = lazy(
  async () => await import("../pages/shared/services/sale-channels/overview/overview")
);
export const SaleChannelsMarketplace = lazy(
  async () => await import("../pages/shared/services/sale-channels/marketplace/marketplace")
);
